import { render, staticRenderFns } from "./block4.vue?vue&type=template&id=0a97627b&scoped=true"
import script from "./block4.vue?vue&type=script&lang=js"
export * from "./block4.vue?vue&type=script&lang=js"
import style0 from "./block4.vue?vue&type=style&index=0&id=0a97627b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a97627b",
  null
  
)

export default component.exports